<template>
	<div class='wrap wrap--840' >
		<Stepper v-bind="{...currentProperties}"  />
	</div>
</template>

<script>

import './scss/index.scss'

// import CollapsiblePart from './story/collapsible/index.vue';
import Stepper from './story/stepper/index.vue';

export default {
	name: 'App',
	mounted: function() {},
	components: {Stepper},
	data: function() {
		console.log(this.$store.state.data.paragraaf[0])
		return {
			currentProperties: this.$store.state.data.paragraaf[0]
		}
	}
}
</script>
